import { clsx } from 'clsx';

interface IUserLayoutTitleProps extends ICustomizable {
  children: React.ReactNode;
}

export const UserLayoutTitle = (props: IUserLayoutTitleProps) => (
  <h1 className={clsx('layout-title', props.className)}>{props.children}</h1>
);
